import { MutationCache, QueryCache, QueryClient } from 'react-query';

import { isAxiosError } from '@app/libs/axios/isAxiosError';
import { logger } from '@app/libs/datadog';

/**
 * @FIXME
 * dataLayerMiddleware.ts에서 queryClient에 의존하는
 * mutate들이 모두 useMutation으로 마이그레이션되면 export를 제거해주세요.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      notifyOnChangeProps: 'tracked',
      retry: (count, e) => {
        if (isAxiosError(e)) {
          const status = e.response?.status;
          if (status && status >= 400 && status < 500) {
            return false;
          }
        }
        if (count < 3) {
          return true;
        }
        return false;
      },
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      if (error instanceof Error) {
        logger.error(error.message, error);
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (error instanceof Error) {
        logger.error(error.message, error);
      }
    },
  }),
});
